'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var text = {
  fontFamily: 'Source Sans Pro',
  variants: {
    "default": {
      fontSize: ['15px'],
      lineHeight: ['19px'],
      fontWeight: 400,
      margin: 0
    },
    bold: {
      fontSize: ['15px'],
      lineHeight: ['20px'],
      fontWeight: 600,
      margin: 0
    },
    small: {
      fontSize: ['11px'],
      lineHeight: ['14px'],
      fontWeight: 400,
      margin: 0
    },
    secondary: {
      fontSize: ['13px'],
      lineHeight: ['16px'],
      fontWeight: 400,
      margin: 0
    },
    subtitle: {
      fontSize: ['18px'],
      lineHeight: ['22px'],
      fontWeight: 600,
      margin: 0
    },
    title: {
      fontSize: ['22px'],
      lineHeight: ['28px'],
      fontWeight: 600,
      margin: 0
    }
  }
};

exports.default = text;
